import * as _ from "lodash";
import {UserGroupCollection} from "../../../collections/UserGroups";
import * as Backbone from "backbone";
import {BaseInternalView} from "../../_BaseViews";
import {Intercom} from "../../../common/intercom";
import {TimezoneCollection} from "../../../collections/Timezones";
import {UserCollection} from "../../../collections/Users";
import {BaseAccountViewOptions} from "../_BaseAccountViews";

var validator = require('validator');

export interface AccountTeamModifyOptions extends BaseAccountViewOptions {
    userGroupCollection: UserGroupCollection;
    userCollection: UserCollection;
}

export interface AccountAddUserOptions extends AccountTeamModifyOptions {
    currentUserGroupId?: number
}

export class ModifyTeamModal extends BaseInternalView {
    options: AccountTeamModifyOptions;
    template = _.template(require('../../../templates/account/team/modifyTeam.html'));

    constructor(options: AccountTeamModifyOptions) {
        super(<any> _.extend({
            tagName: 'div',
            events: {
                'hidden.bs.modal #addTeamModalLabel': 'handleModalHidden',
                'click .add-team-btn': 'handleCreateGroupSubmitButtonClick',
            }
        }, options));
    }

    render() {
        this.$el.html(this.template({
            installCollection       : this.options.installCollection,
            organizationCollection  : this.options.organizationCollection,
            permissionCollection    : this.options.permissionCollection,
            appCollection           : this.options.appCollection,
        }));

        (<any> this.$('.latlong input[type="checkbox"]')).bootstrapToggle();
        return this;
    }

    hide() {
        (<any> this.$('#addTeamModalLabel')).modal('hide');
    }

    show() {
        (<any> this.$('#addTeamModalLabel')).modal('show');
    }

    handleModalHidden() {
        this.remove();
    }

    setFormError() {
        this.$('.modal-footer button').removeClass('hidden');
        this.$('.modal-footer .modal-form-spinner').addClass('hidden');
    }

    setFormSubmitted() {
        this.$('.modal-body button').addClass('hidden');
        this.$('.modal-body .modal-form-spinner').removeClass('hidden');
    }

    handleCreateGroupSubmitButtonClick(e: JQuery.UIEventBase) {
        e.preventDefault();
        var errorsSelector = this.$('.create-group-form-errors');
        errorsSelector.addClass('hidden');

        var name = (<string> this.$('.create-group-form-name').val()).trim();

        var errors = [];
        if(name.length === 0) errors.push('Team Name may not be empty');

        if (this.options.userGroupCollection.find((m) => {
                return m.get('name').toLowerCase() == name.toLowerCase()
            })) {
            errors.push('A team with this name already exists');
        }

        if(errors.length){
            this.setFormError();
            errorsSelector.find('ul').html(_.map(errors, (e) => {
                return '<li>' + e + '</li>'
            }).join(''));
            errorsSelector.removeClass('hidden');
            return
        }

        this.setFormSubmitted();

        $.ajax({
            type: "POST",
            url: this.options.userGroupCollection.url(),
            data:  JSON.stringify({
                name: name
            }),
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            complete: (response) => {
                var id;
                if(response.responseJSON){
                    id = response.responseJSON.userGroupId;
                }
                this.refetchCollectionsAndRerender(id);

                Intercom.trackEvent('created-team', {
                    org_id: this.options.currentOrganizationId,
                    team_id: id
                });
            }
        });
    }

    refetchCollectionsAndRerender(groupId?) {
        var d1 = this.options.userGroupCollection.fetch({reset: true});
        var d2 = this.options.permissionCollection.fetch({reset: true});

        $.when(d1, d2).done(() => {
            this.hide();
            Backbone.history.loadUrl();
        }).fail(() => {
            this.setFormError();
        })
    }
}

export class AddUserModal extends BaseInternalView {
    options: AccountAddUserOptions;
    template = _.template(require('../../../templates/account/team/addUser.html'));

    constructor(options: AccountAddUserOptions) {
        super(<any> _.extend({}, options, {
            tagName: 'div',
            events: {
                'hidden.bs.modal #addUserModalLabel': 'handleModalHidden',
                'shown.bs.modal #addUserModalLabel': 'handleModalShown',
                // 'click .invite-user-cancel-button': 'handleModalHidden',
                'click .add-user-btn': 'handleInviteUserSubmitButtonClick'
            }
        }));
    }

    render() {
        var users = [];
        if(this.options.currentUserGroupId) {
            users = this.options.userCollection.filter((user) => {
                return !_.has(user.get('usergroups'), String(this.options.currentUserGroupId));
            });
        }

        this.$el.html(this.template({
            installCollection       : this.options.installCollection,
            organization            : this.options.organizationCollection.findWhere({id: this.options.currentOrganizationId}),
            userGroup               : this.options.currentUserGroupId ? this.options.userGroupCollection.findWhere({id: this.options.currentUserGroupId}) : null,
            users                   : users,
            userCollection          : this.options.userCollection,
            organizationCollection  : this.options.organizationCollection,
            userGroupCollection     : this.options.userGroupCollection,
            permissionCollection    : this.options.permissionCollection,
            appCollection           : this.options.appCollection,
            timezones               : new TimezoneCollection()

        }));

        (<any> this.$('.latlong input[type="checkbox"]')).bootstrapToggle();

        // this.delegateEvents();

        return this;
    }

    hide() {
        (<any> this.$('#addUserModalLabel')).modal('hide');
    }

    show() {
        (<any> this.$('#addUserModalLabel')).modal('show');
    }

    handleModalHidden() {
        this.remove();
    }

    handleModalShown() {
        this.$('.invite-user-form-name').focus();
    }

    setFormError() {
        this.$('.modal-footer button').removeClass('hidden');
        this.$('.modal-footer .modal-form-spinner').addClass('hidden');
    }

    setFormSubmitted() {
        this.$('.modal-body button').addClass('hidden');
        this.$('.modal-body .modal-form-spinner').removeClass('hidden');
    }

    handleInviteUserSubmitButtonClick(e) {
        e.preventDefault();
        var errorsSelector = this.$('.invite-user-form-errors');
        errorsSelector.addClass('hidden');

        var userId = this.$('.account-modify-team-add-user-select').val();
        if(userId) {
            var existingUser = this.options.userCollection.findWhere({id: Number(userId)});

        } else {
            var name = (<string> this.$('.invite-user-form-name').val()).trim();
            var company = (<string> this.$('.invite-user-form-company').val()).trim();
            var role = (<string> this.$('.invite-user-form-role').val()).trim();
            var email = (<string>this.$('.invite-user-form-email').val()).trim().toLowerCase();
            var phone = (<string> this.$('.invite-user-form-phone').val()).trim();
            var phoneValidator = /^[().+\d -]{7,15}$/;
            var team = Number((<string> this.$('.invite-user-form-team').val()));
            var timezone = (<string> this.$('.invite-user-form-timezone').val());

            var errors = [];
            if(name.length === 0) errors.push('Name may not be empty');
            if(email.length === 0) errors.push('Email Address may not be empty');

            if(!validator.isEmail(email)) errors.push('Email Address is not valid');
            if(phone && !phone.match(phoneValidator)) errors.push('Phone Number is not valid (must include area code)');

            if(errors.length){
                this.setFormError();
                errorsSelector.find('ul').html(_.map(errors, (e) => {
                    return '<li>' + e + '</li>'
                }).join(''));
                this.$('.invite-user-form-errors').removeClass('hidden');
                return
            }

            if(!phone) phone = null;
            if(!company) company = null;
            if(!role) role = null;
            this.setFormSubmitted();
        }

        $.ajax({
            type: "POST",
            url: this.options.userCollection.url(),
            data:  JSON.stringify({
                name: existingUser ? existingUser.get('name') : name,
                company_name: existingUser ? existingUser.get('company_name') : company,
                company_role: existingUser ? existingUser.get('company_role') : role,
                email: existingUser ? existingUser.get('email') : email,
                phone_number: existingUser ? existingUser.get('phone_number') : phone,
                usergroup: team ? team : this.options.currentUserGroupId,
                timezone: existingUser ? existingUser.get('timezone') : timezone
            }),
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            complete: () => {
                this.refetchCollectionsAndRerender(this.options.currentUserGroupId);
                if(!userId) {
                    Intercom.trackEvent('invited-user', {
                        org_id: this.options.currentOrganizationId,
                        team_id: this.options.currentUserGroupId,
                        email: email
                    });
                }
            }
        });
    }

    refetchCollectionsAndRerender(groupId?) {
        var d1 = this.options.permissionCollection.fetch({reset: true});
        var d2 = this.options.userGroupCollection.fetch({reset: true});
        var d3 = this.options.userCollection.fetch({reset: true});

        $.when(d1, d2, d3).done(() => {
            this.hide();
            Backbone.history.loadUrl();
        }).fail(() => {
            this.setFormError();
        })
    }

    remove() {
        return super.remove();
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/account/team/TeamModals.ts